const tidMixin = {
    methods: {
        setSelectedTids(tids){
            let retval = [];
            Object.entries(tids).forEach(([key, value]) => {
                retval.push(value.pos_id);
                if(key > 2000000) return [];
            });
            return retval
        }
    }
};

export default tidMixin;